import {useState} from 'react';
import type {SmtRuntimePort} from '../contracts.ts';
import type {SmtBusinessDayPort} from '../smt-business-day-port.ts';
import type {SmtBusinessDayIntent,SmtBusinessDayViewModel} from '../../../../packages/runtime/smt-business-day-contract.ts';

type RuntimeWithBusinessDay=SmtRuntimePort&Partial<SmtBusinessDayPort>;

const intakeLabel=(status:SmtBusinessDayViewModel['customerIntakeStatus'])=>status==='open'?'接單中':status==='paused'?'暫停接單':'停止接單';

export function P01CustomerIntakeControl({runtime}:{runtime:SmtRuntimePort}){
  const port=runtime as RuntimeWithBusinessDay;
  const [open,setOpen]=useState(false);
  const [snapshot,setSnapshot]=useState<SmtBusinessDayViewModel|null>(null);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState<string|null>(null);
  const [earlyCloseAt,setEarlyCloseAt]=useState('');

  const load=async()=>{
    if(!port.readBusinessDay){setError('營業控制未連接');return null;}
    setLoading(true);setError(null);
    try{const next=await port.readBusinessDay();setSnapshot(next);return next;}catch(reason){setError(reason instanceof Error?reason.message:'BUSINESS_DAY_READ_FAILED');return null;}finally{setLoading(false);}
  };
  const openSheet=()=>{setOpen(true);void load();};
  const dispatch=async(intent:SmtBusinessDayIntent,current=snapshot)=>{
    if(!current||!port.dispatchBusinessDay)return current;
    setLoading(true);setError(null);
    try{
      const result=await port.dispatchBusinessDay(intent,current.revision);
      setSnapshot(result.snapshot);
      if(result.kind==='rejected')setError(result.code);
      return result.snapshot;
    }catch(reason){setError(reason instanceof Error?reason.message:'BUSINESS_DAY_WRITE_FAILED');return current;}finally{setLoading(false);}
  };
  const setOpenIntake=async()=>{
    if(!snapshot||!port.readBusinessDay)return;
    let current=snapshot;
    if(current.serviceStatus!=='open')current=(await dispatch({kind:'service.open'},current))??current;
    const fresh=await port.readBusinessDay();
    if(!fresh)return;
    setSnapshot(fresh);
    if(fresh.customerIntakeStatus!=='open')await dispatch({kind:'customer-intake.set',status:'open'},fresh);
  };

  return <>
    <button type="button" className="customer-status-entry" onClick={openSheet}><span>客戶端</span><small>{snapshot?intakeLabel(snapshot.customerIntakeStatus):'營業／暫停入口'}</small></button>
    {open?<div className="p01u-overlay" role="presentation" onClick={event=>{if(event.target===event.currentTarget)setOpen(false)}}>
      <section className="p01u-intake-card" role="dialog" aria-modal="true" aria-label="客戶端營業控制">
        <header><div><small>CUSTOMER INTAKE</small><h2>客戶端營業控制</h2></div><button aria-label="關閉客戶端營業控制" onClick={()=>setOpen(false)}>×</button></header>
        {loading&&!snapshot?<p className="intake-loading">讀取中…</p>:snapshot?<>
          <div className="intake-current"><div><small>營業日</small><b>{snapshot.businessDate}</b></div><div><small>服務</small><b>{snapshot.serviceStatus==='open'?'營業':'休息'}</b></div><div><small>客戶端</small><b>{intakeLabel(snapshot.customerIntakeStatus)}</b></div></div>
          <div className="intake-actions">
            <button className="open" disabled={loading||snapshot.customerIntakeStatus==='open'} onClick={()=>void setOpenIntake()}><b>接單</b><small>恢復客戶端落單</small></button>
            <button disabled={loading||snapshot.customerIntakeStatus==='paused'} onClick={()=>void dispatch({kind:'customer-intake.set',status:'paused',reason:'SMT 暫停接單'})}><b>暫停接單</b><small>店內仍可營運</small></button>
            <button className="danger" disabled={loading||snapshot.customerIntakeStatus==='closed'} onClick={()=>void dispatch({kind:'customer-intake.set',status:'closed',reason:'SMT 今日停止接單'})}><b>今日休息</b><small>客戶端停止接單</small></button>
          </div>
          <section className="early-close-control"><div><b>提早休息</b><small>{snapshot.earlyClosePlan?`已設定 ${new Date(snapshot.earlyClosePlan.effectiveAt).toLocaleTimeString('zh-HK',{hour:'2-digit',minute:'2-digit',hour12:false})}`:'設定今日提早停止接單時間'}</small></div>{snapshot.earlyClosePlan?<button onClick={()=>void dispatch({kind:'early-close.cancel'})}>取消提早休息</button>:<><input type="datetime-local" value={earlyCloseAt} onChange={event=>setEarlyCloseAt(event.currentTarget.value)}/><button disabled={!earlyCloseAt} onClick={()=>void dispatch({kind:'early-close.plan',effectiveAt:new Date(earlyCloseAt).toISOString(),reason:'SMT 提早休息'})}>設定</button></>}</section>
        </>:<div className="intake-empty"><b>未開營業日</b><span>要先喺今日營運開啟 Business Day，先可以控制客戶端接單。</span></div>}
        {error?<p className="intake-error" role="alert">{error}</p>:null}
      </section>
    </div>:null}
  </>;
}
